import { render, staticRenderFns } from "./CriarAcao.vue?vue&type=template&id=2c1c256e&scoped=true"
import script from "./CriarAcao.vue?vue&type=script&lang=js"
export * from "./CriarAcao.vue?vue&type=script&lang=js"
import style0 from "./CriarAcao.vue?vue&type=style&index=0&id=2c1c256e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1c256e",
  null
  
)

export default component.exports